var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ques-style"},[_c('div',{staticClass:"t1"},[_vm._v(_vm._s(_vm.language==1?_vm.info.title:_vm.info.Etitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.language==1?_vm.info.content:_vm.info.Econtent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }